import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuSeparator,
} from '@/components/ui/context-menu';
import { ProBadge } from '@/components/ProBadge';
import type { AddableLayerType } from '@/lib/layers/layerTypeConfig';
import { LAYER_MENU_ITEMS } from './layerMenuItems';

/**
 * The "Adicionar camada" section of a context menu: a PRO-badged label, a
 * separator, and one row per layer type. Rendered inside both the preview
 * canvas menu (`AddLayerContextMenu`) and the timeline's existing context menu,
 * from the same `LAYER_MENU_ITEMS` the toolbar dropdown uses.
 *
 * Uses `onClick` rather than Radix's `onSelect` to preserve user activation
 * for upload fallbacks. Image, video and audio open media picker dialogs.
 */
export const AddLayerContextMenuRows: React.FC<{
  onAdd: (type: AddableLayerType) => void;
}> = ({ onAdd }) => {
  const { t } = useTranslation();

  return (
    <>
      <ContextMenuLabel className="flex items-center justify-between gap-3 py-1 text-xs font-normal text-muted-foreground">
        {t('projectEditor.layers.add')}
        <ProBadge />
      </ContextMenuLabel>
      <ContextMenuSeparator />
      {LAYER_MENU_ITEMS.map(({ type, Icon, labelKey }) => (
        <ContextMenuItem
          key={type}
          data-testid={`context-add-layer-${type}`}
          onClick={() => onAdd(type)}
        >
          <Icon className="mr-2 h-4 w-4" />
          {t(labelKey)}
        </ContextMenuItem>
      ))}
    </>
  );
};

export default AddLayerContextMenuRows;
